import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsumoInserirComponent } from './consumo-inserir.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: ConsumoInserirComponent}
  ])],
  exports: [RouterModule]
})
export class ConsumoInserirRoutingModule { }
